import React, { Fragment } from 'react';

/* mui */
import Typography from '@material-ui/core/Typography';
/* mui */

/* packages */
import { ModuleWrapperInfo } from '../../util-atomic-design';
/* packages */

const index = ({productId, productName, path}) => {
  return <ModuleWrapperInfo>
    <img width="50%" src={path} />
    <br/>
    <Typography variant="h6">
      <b>{ productName }</b>
    </Typography>
  </ModuleWrapperInfo>
}

export default index;
